(function() {
	const selectors = '.gardp-counter[data-target]';
	const counters = new Set();

	function formatCounterNumber(value, precision) {
		return value.toLocaleString('en-US', {
			minimumFractionDigits: precision,
			maximumFractionDigits: precision
		});
	}

	function animateCounter(el) {
		const target = parseFloat(el.dataset.target || '0');
		const start = parseFloat(el.dataset.start || '0');
		const duration = Math.max(0, parseInt(el.dataset.duration || '1500', 10));
		const prefix = el.dataset.prefix || '';
		const suffix = el.dataset.suffix || '';
		const precision = parseInt(el.dataset.precision || '0', 10);
		const once = (el.dataset.once || 'true') === 'true';

		const numberSpan = el.querySelector('.gardp-counter__number');
		const prefixSpan = el.querySelector('.gardp-counter__prefix');
		const suffixSpan = el.querySelector('.gardp-counter__suffix');
		if (!numberSpan) return;

		if (prefixSpan) {
			prefixSpan.textContent = prefix;
		}

		if (suffixSpan) {
			suffixSpan.textContent = suffix;
		}

		let startTime = null;
		const delta = target - start;

		function step(timestamp) {
			if (!startTime) startTime = timestamp;
			const elapsed = timestamp - startTime;
			const progress = duration === 0 ? 1 : Math.min(elapsed / duration, 1);
			const eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
			const value = start + delta * eased;
			numberSpan.textContent = formatCounterNumber(value, precision);

			if (progress < 1) {
				requestAnimationFrame(step);
			} else if (!once) {
				// allow retrigger if once is false
				counters.delete(el);
			}
		}

		requestAnimationFrame(step);
		if (once) {
			counters.add(el);
		}
	}

	function initCounter(el) {
		if (counters.has(el)) return;
		animateCounter(el);
	}

	if ('IntersectionObserver' in window) {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					initCounter(entry.target);
				}
			});
		}, { threshold: 0.3 });

		document.querySelectorAll(selectors).forEach((el) => observer.observe(el));
	} else {
		// Fallback: run immediately
		document.querySelectorAll(selectors).forEach(initCounter);
	}
})();
